<div class="rm-header">
  <span>{{data.deal.projectName}}</span>
</div>

<!-- <div class="user-logged-in" *ngIf="userLoggedIn">
    <div mat-dialog-content>
        <div class="row justify-content-center pb-2">
            <span>Please let us know a bit more about your interest in this deal</span>
        </div>
        <div class="row justify-content-center pt-1">
            <form [formGroup]="fgUser">
                <mat-form-field class="form-field">
                    <mat-label>Notes</mat-label>
                    <textarea id="reason" matInput placeholder="Type here..." formControlName="notes"></textarea>
                </mat-form-field>
            </form>
        </div>
    </div>
    <div mat-dialog-actions class="space-between">
        <button mat-raised-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" (click)="expressInterest()">Express Interest</button>
    </div>
</div> -->

<div class="user-guest">
    <div mat-dialog-content *ngIf="displayGuestForm == false">
        <p>
            By registering on the platform, you will be able to request a match to this opportunity, and unlock full deal information.
        </p>

        <p>
            Already registered? Login to continue.
        </p>

        <div class="mt-4" style="display: flex; width: 100%; flex-direction: column; gap: 10px; align-items: center; justify-content: center;">
            <button class="full-width" color="primary" mat-raised-button (click)="routeToRegister()">Register</button>
            <button class="full-width" color="primary" mat-raised-button (click)="routeToLogin()">Login</button>
            <a class="link no-underline pt-1" (click)="changeToGuestForm()">Or request information as a guest</a>
        </div>
    </div>

    <div *ngIf="displayGuestForm" class="text-center">
        <div mat-dialog-content>
            <form  [formGroup]="fgGuest" *ngIf="displayGuestForm">
                <mat-form-field class="form-field">
                    <mat-label>Name</mat-label>
                    <input id="name" matInput placeholder="Type here..." formControlName="name">
                    <mat-error *ngIf="fgGuest.get('name')?.invalid && (fgGuest.get('name')?.touched || fgGuest.get('name')?.dirty)">
                    Name is required.
                    </mat-error>
                </mat-form-field>

                <div class="form-align">
                    <mat-form-field class="form-field">
                        <mat-label>Email</mat-label>
                        <input id="email" matInput placeholder="Type here..." formControlName="email">
                        <mat-error *ngIf="fgGuest.get('email')?.invalid && (fgGuest.get('email')?.touched || fgGuest.get('email')?.dirty)">
                        A valid email is required.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field">
                        <mat-label>Phone</mat-label>
                        <input id="phone" matInput placeholder="Type here..." formControlName="phone">
                    </mat-form-field>
                </div>

                <div class="form-align">
                    <mat-form-field class="form-field">
                        <mat-label>Company</mat-label>
                        <input id="company" matInput placeholder="Company Name" formControlName="company">
                        <mat-error *ngIf="fgGuest.get('company')?.invalid && (fgGuest.get('company')?.touched || fgGuest.get('company')?.dirty)">
                        Company name is required.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field">
                        <mat-label>Title</mat-label>
                        <input id="title" matInput placeholder="Your Title" formControlName="title">
                        <mat-error *ngIf="fgGuest.get('title')?.invalid && (fgGuest.get('title')?.touched || fgGuest.get('title')?.dirty)">
                        Title at the company is required.
                        </mat-error>
                    </mat-form-field>
                </div>


                <mat-form-field class="form-field">
                    <mat-label>Notes (optional)</mat-label>
                    <textarea id="notes" matInput placeholder="Type any additional notes here..." formControlName="notes"></textarea>
                </mat-form-field>
            </form> 
        </div>
        <div mat-dialog-actions class="space-between">
            <button mat-raised-button mat-dialog-close>Cancel</button>
            <button mat-raised-button color="primary" (click)="sendGuestInterest()">Request More Information</button>
        </div>
    </div>
</div>